/**
 * Gente con la que has jugado hace poco.
 *
 * Es la forma mas natural de hacer amigos en un juego: acabas un partido con
 * alguien que juega bien (o que se rie en el chat) y quieres volver a jugar
 * con el. Sin esto habia que acordarse de su nombre y buscarlo; ahora sale en
 * la pestaña de amigos con un "Añadir" al lado.
 *
 * Vive en el navegador: es tu historial, no hace falta que lo sepa nadie mas.
 */
export interface RecentPlayer {
  clientId: string;
  nickname: string;
  at: number;
}

const KEY = "fynta.recentPlayers";
const LIMIT = 16;

export function loadRecentPlayers(): RecentPlayer[] {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? "[]") as unknown;
    if (!Array.isArray(raw)) return [];
    return raw
      .filter(
        (p): p is RecentPlayer =>
          typeof p === "object" &&
          p !== null &&
          typeof (p as RecentPlayer).clientId === "string" &&
          typeof (p as RecentPlayer).nickname === "string" &&
          typeof (p as RecentPlayer).at === "number",
      )
      .slice(0, LIMIT);
  } catch {
    return [];
  }
}

/** Apunta a los de este partido (sin contarte a ti), los ultimos primero. */
export function rememberPlayers(players: ReadonlyArray<{ clientId: string; nickname: string }>, selfId: string, now = Date.now()): void {
  const fresh = players.filter((p) => p.clientId && p.clientId !== selfId);
  if (fresh.length === 0) return;
  const ids = new Set(fresh.map((p) => p.clientId));
  const next = [
    ...fresh.map((p) => ({ clientId: p.clientId, nickname: p.nickname, at: now })),
    ...loadRecentPlayers().filter((p) => !ids.has(p.clientId)),
  ].slice(0, LIMIT);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Sin almacenamiento: no se recuerda, y ya.
  }
}
